import { combineReducers } from 'redux'
import { createTransform, persistReducer, createMigrate } from 'redux-persist'
import createWebStorage from 'redux-persist/lib/storage/createWebStorage'
import { parse, stringify } from 'flatted'

import userReducer, { initialState } from './user'
import reportReducer from './report'
import analysisReducer from './analysis'
import loadingReducer from './loading'
import etlReducer from './etl'
import ptReducer from './pt'

const createNoopStorage = () => ({
  getItem() {
    return Promise.resolve(null)
  },
  setItem(_: any, value: any) {
    return Promise.resolve(value)
  },
  removeItem() {
    return Promise.resolve()
  },
})

const storage = typeof window !== 'undefined' ? createWebStorage('local') : createNoopStorage()

export const transformCircular = createTransform(
  (inboundState) => stringify(inboundState),
  (outboundState) => parse(outboundState),
)

const migrations = {
  2: (state: any) => ({
    ...state,
    currentUser: initialState,
  }),
}

const persistConfig = {
  key: 'root',
  storage,
  version: 2,
  whitelist: ['currentUser'],
  migrate: createMigrate(migrations, { debug: false }),
  transforms: [transformCircular],
}

const rootReducer = combineReducers({
  currentUser: userReducer,
  currentReport: reportReducer,
  currentAnalysis: analysisReducer,
  currentLoading: loadingReducer,
  currentEtl: etlReducer,
  currentPt: ptReducer
})

const persistedReducer = persistReducer<ReturnType<typeof rootReducer>>(persistConfig, rootReducer)

export default persistedReducer
